import { Map } from 'immutable';

export function request(state, { userId, value }) {
    let multiples = state
        .getIn([ 'multiples', userId ], Map())
        .filter(m => m.get('type') !== value);

    return state.setIn([ 'multiples', userId ], multiples);
}
